module.exports = __webpack_public_path__ + "img/code.cbd54083.png";